import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IPaymentApiClient } from './i-payment.api.client';
import { IPaginationParameters, IPaginationResponse } from '../../../common';
import { paymentsData } from '../data';
import { IPaymentRequestResponse, paymentRequestsData } from '../../payment-request';
import { IPaymentLookupsResponse, IPaymentResponse } from '../dtos/responses';

@Injectable({
  providedIn: 'root'
})
export class PaymentInMemoryApiClient implements IPaymentApiClient {
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IPaymentResponse>> {
    return of(paymentsData.paymentsResponse);
  }

  getById(id: string): Observable<IPaymentResponse> {
    return of(paymentsData.paymentResponse);
  }

  getPaymentRequest(id: string): Observable<IPaymentRequestResponse> {
    return of(paymentRequestsData.paymentRequestResponse);
  }

   lookups(): Observable<IPaymentLookupsResponse> {
    return of(paymentsData.lookups);
  }
}
